import { IUser } from './notification';

/**
 * Interface for document file information
 */
export interface IOrderDocumentFile {
  url: string;
  name: string;
  size: number;
  type?: string;
}

/**
 * Document types available for orders
 */
export const ORDER_DOCUMENT_TYPES = {
  PURCHASE_ORDER: 'purchase_order',
  DELIVERY_SHEET: 'delivery_sheet',
  EMAIL_APPROVAL: 'email_approval',
  OTHER: 'other',
} as const;

export type OrderDocumentType = (typeof ORDER_DOCUMENT_TYPES)[keyof typeof ORDER_DOCUMENT_TYPES];

/**
 * Interface for order documents
 */
export interface IOrderDocument {
  _id: string;
  documentType: OrderDocumentType;
  number?: string;
  description?: string;
  documentDate?: string | Date;
  file?: IOrderDocumentFile;
  amount?: number;
  organization?: string;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  submittedBy?: IUser;
  originalBlob?: string;
}
